import React from 'react';
import CRPBlockWrapper from './CRPBlockWrapper';

const BLOCK_TITLE = "Standard";

export default function CRPStandardBlock({ title, description }) {
  return (
    <CRPBlockWrapper title={BLOCK_TITLE}>
      <div className='standardBlock'>
        <div className='standardTitle'>{title}</div>
        <div className='description'>{description}</div>
      </div>
    </CRPBlockWrapper>
  )
}